const ACTIVE_CLASS = "active";
const BODY_CLASS = "scroll-lock";

class Modal {
	// @element - id of the modal or the modal itself (HTMLElement)
	constructor(element) {
		if (typeof element === "string") {
			this._$element = document.getElementById(`xyl-modal-${element}`);
		} else {
			this._$element = element;
		}
	}

	toggle() {
		document.body.classList.toggle(BODY_CLASS);
		this._$element.classList.toggle(ACTIVE_CLASS);
	}

	open() {
		document.body.classList.add(BODY_CLASS);
		if (this._$element) {
			this._$element.classList.add(ACTIVE_CLASS);
		}
	}

	close() {
		document.body.classList.remove(BODY_CLASS);
		if (this._$element) {
			this._$element.classList.remove(ACTIVE_CLASS);
		}
	}
}

export { ACTIVE_CLASS, BODY_CLASS, Modal };
